import * as DocumentPicker from 'expo-document-picker';
import { useEffect, useState } from 'react';

interface UseUploadDocumentProps {
  onValueChange: (document: undefined | DocumentPicker.DocumentResult) => void;
  type?: string; // MIME type
}

export const useUploadDocument = ({ type = '*/*', onValueChange }: UseUploadDocumentProps) => {
  const [selectedDocument, setSelectedDocument] = useState<undefined | DocumentPicker.DocumentResult>(undefined);

  const pickDocument = async () => {
    const uploaderResult = await DocumentPicker.getDocumentAsync({
      type,
      multiple: true,
      copyToCacheDirectory: true
    });

    setSelectedDocument(uploaderResult);
  };

  const removeDocument = () => {
    setSelectedDocument(undefined);
  };

  useEffect(() => {
    onValueChange(selectedDocument);
    return () => {
      onValueChange(undefined);
    };
  }, [selectedDocument]);

  return {
    selectedDocument,
    pickDocument,
    removeDocument
  };
};
